export default __webpack_public_path__ + "static/media/ico-bug-score-low.38b842d8.svg";